import { environment } from './../../../../environment/environment';
import { Injectable } from '@angular/core';
import { ApiResponse } from '../../models/response-api';
import { HttpClient } from '@angular/common/http';
import { CrudService } from '../crud-service/crud.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FAQService extends CrudService<ApiResponse<any>, number> {
  constructor(_http: HttpClient) {
    super(_http, `${environment.baseUrl}`);
  }
  /* get all FAQ */
  getAllFaq(perpage: number, page: number): Observable<ApiResponse<any>> {
    console.log(
      'url',
      this._base +
        '/api/FAQ/getListFAQwithResponse?type=3' +
        '&per_page=' +
        perpage +
        '&page=' +
        page
    );
    return this._http.get<ApiResponse<any>>(
      this._base +
        '/api/FAQ/getListFAQwithResponse?type=3' +
        '&per_page=' +
        perpage +
        '&page=' +
        page
    );
  }
  getAllFaqESN(perpage: number, page: number): Observable<ApiResponse<any>> {
    return this._http.get<ApiResponse<any>>(
      this._base +
        '/api/FAQ/getListFAQwithResponse?type=2' +
        '&per_page=' +
        perpage +
        '&page=' +
        page
    );
  }
  searchfaq(data: any) {
    console.log(
      'url search faq',
      this._base + `/api/FAQ/filterinListFAQwithResponse`,
      data
    );
    return this._http.post<ApiResponse<any>>(
      this._base + `/api/FAQ/filterinListFAQwithResponse`,
      data
    );
  }
}
